import {Box, Heading, IconButton, Table, TableCaption, Tbody, Td, Tfoot, Thead, Tr} from '@chakra-ui/react';
import React from 'react';
import {useFieldArray} from 'react-hook-form';
import {FaTrash, FaUserPlus} from 'react-icons/fa';
import ServiceTypes from '../../../../constants/ServiceTypes';
import {getServiceType, getServiceTypes} from '../../../../helpers/ServiceTypeDictionary';
import {CustomCheckbox, CustomInput, CustomSelect} from '../../../General/FormInputs';

const AddBonus = ({control, register, errors, bonuses}) => {
  const serviceTypes = getServiceTypes();
  const {fields, append, remove} = useFieldArray({
    control,
    name: 'bonuses',
  });

  // useEffect(() => {
  //   swap(bonuses);
  // }, [bonuses]);

  return (
    <>
      <Table variant="striped" colorScheme="mint" size={'md'}>
        <TableCaption>Additional Bonuses</TableCaption>
        <Thead>
          <Tr>
            <Td>
              <Heading size="md">Description</Heading>
            </Td>
            <Td>
              <Heading size="md">Amount</Heading>
            </Td>
            <Td>
              <Heading size="md">Service Type</Heading>
            </Td>
            <Td />
            <Td />
            <Td>
              <IconButton
                icon={<FaUserPlus />}
                variant="outline"
                colorScheme={'secondary'}
                title="Add Bonus"
                onClick={() =>
                  append({
                    id: '0',
                    descript: '',
                    amount: 0,
                    csvctype: getServiceType(ServiceTypes.FUNERAL).graystoneCode,
                    lprintzero: false,
                    lsuppressp: false,
                  })
                }
              />
            </Td>
          </Tr>
        </Thead>
        <Tbody>
          {fields.map((item, index) => {
            return (
              <Tr key={item.id}>
                <Td w="25%" px="2">
                  <CustomInput register={register} id={`bonuses.${index}.descript`} name="Description" errors={errors} required />
                  {/** Hidden value of the bonus ID */}
                  <input {...register(`bonuses.${index}.id`)} style={{display: 'none'}} />
                </Td>
                <Td w="20%" px="2">
                  <CustomInput register={register} id={`bonuses.${index}.amount`} name="Amount" errors={errors} />
                </Td>
                <Td w="25%" px="2">
                  <CustomSelect register={register} id={`bonuses.${index}.csvctype`} name={'Service type'} errors={errors}>
                    {serviceTypes.map(svc => {
                      return (
                        <option key={svc.value} value={svc.graystoneCode}>
                          {svc.key}
                        </option>
                      );
                    })}
                  </CustomSelect>
                </Td>
                <Td w="25%" px="2">
                  <Box>
                    <CustomCheckbox control={control} id={`bonuses.${index}.lprintzero`} name="Print if zero?" errors={errors} />
                    <CustomCheckbox control={control} id={`bonuses.${index}.lsuppressp`} name="Suppress Print" errors={errors} />
                  </Box>
                </Td>
                <Td />

                <Td w="5%">
                  <IconButton
                    colorScheme="tertiary"
                    title="Delete"
                    size="md"
                    icon={<FaTrash />}
                    mr="2"
                    onClick={() => {
                      remove(index);
                    }}
                  />
                </Td>
              </Tr>
            );
          })}
        </Tbody>
        <Tfoot></Tfoot>
      </Table>
    </>
  );
};

export default AddBonus;
